"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Insights
 * OpenApi specification for the Insights.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetConfigurationsToJSON = exports.WidgetConfigurationsFromJSONTyped = exports.WidgetConfigurationsFromJSON = void 0;
var BubbleMapConfigObject_1 = require("./BubbleMapConfigObject");
var ChartConfigObject_1 = require("./ChartConfigObject");
var GroupBarChartConfigObject_1 = require("./GroupBarChartConfigObject");
var MultiAreaChartConfigObject_1 = require("./MultiAreaChartConfigObject");
var PieChartConfigObject_1 = require("./PieChartConfigObject");
var TableConfigObject_1 = require("./TableConfigObject");
function WidgetConfigurationsFromJSON(json) {
    return WidgetConfigurationsFromJSONTyped(json, false);
}
exports.WidgetConfigurationsFromJSON = WidgetConfigurationsFromJSON;
function WidgetConfigurationsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['kind']) {
        case 'areaChart':
            return __assign(__assign({}, (0, ChartConfigObject_1.ChartConfigObjectFromJSONTyped)(json, true)), { kind: 'areaChart' });
        case 'barChart':
            return __assign(__assign({}, (0, ChartConfigObject_1.ChartConfigObjectFromJSONTyped)(json, true)), { kind: 'barChart' });
        case 'bubbleMap':
            return __assign(__assign({}, (0, BubbleMapConfigObject_1.BubbleMapConfigObjectFromJSONTyped)(json, true)), { kind: 'bubbleMap' });
        case 'groupBarChart':
            return __assign(__assign({}, (0, GroupBarChartConfigObject_1.GroupBarChartConfigObjectFromJSONTyped)(json, true)), { kind: 'groupBarChart' });
        case 'horizontalBarChart':
            return __assign(__assign({}, (0, ChartConfigObject_1.ChartConfigObjectFromJSONTyped)(json, true)), { kind: 'horizontalBarChart' });
        case 'multiAreaChart':
            return __assign(__assign({}, (0, MultiAreaChartConfigObject_1.MultiAreaChartConfigObjectFromJSONTyped)(json, true)), { kind: 'multiAreaChart' });
        case 'pieChart':
            return __assign(__assign({}, (0, PieChartConfigObject_1.PieChartConfigObjectFromJSONTyped)(json, true)), { kind: 'pieChart' });
        case 'table':
            return __assign(__assign({}, (0, TableConfigObject_1.TableConfigObjectFromJSONTyped)(json, true)), { kind: 'table' });
        default:
            throw new Error("No variant of WidgetConfigurations exists with 'kind=".concat(json['kind'], "'"));
    }
}
exports.WidgetConfigurationsFromJSONTyped = WidgetConfigurationsFromJSONTyped;
function WidgetConfigurationsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['kind']) {
        case 'areaChart':
            return (0, ChartConfigObject_1.ChartConfigObjectToJSON)(value);
        case 'barChart':
            return (0, ChartConfigObject_1.ChartConfigObjectToJSON)(value);
        case 'bubbleMap':
            return (0, BubbleMapConfigObject_1.BubbleMapConfigObjectToJSON)(value);
        case 'groupBarChart':
            return (0, GroupBarChartConfigObject_1.GroupBarChartConfigObjectToJSON)(value);
        case 'horizontalBarChart':
            return (0, ChartConfigObject_1.ChartConfigObjectToJSON)(value);
        case 'multiAreaChart':
            return (0, MultiAreaChartConfigObject_1.MultiAreaChartConfigObjectToJSON)(value);
        case 'pieChart':
            return (0, PieChartConfigObject_1.PieChartConfigObjectToJSON)(value);
        case 'table':
            return (0, TableConfigObject_1.TableConfigObjectToJSON)(value);
        default:
            throw new Error("No variant of WidgetConfigurations exists with 'kind=".concat(value['kind'], "'"));
    }
}
exports.WidgetConfigurationsToJSON = WidgetConfigurationsToJSON;
